import { map, find } from 'lodash';

class TreatmentFormController {
    constructor($rootScope, $scope, $state, treatmentsService, integrationApiService, messageService, markdownService, configService, access) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.integrationApiService = integrationApiService;
        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
        this.marked = markdownService;
        this.configService = configService;
        this.access = access;
    }

    $onInit () {
        if (this.treatment.track_quantity === undefined) {
            this.treatment.track_quantity = this.$rootScope.currentProperty.track_quantity;
        }
        this.treatment = this.treatment || {
            description: ''
        };
        this.isAdmin = this.access.check('admin');
        this.treatment.selectedcategories = this.treatment.categories || [];
        this.treatment.property_id = this.treatment.property_id || this.$rootScope.currentProperty.id;
        this.currentPropertyName = this.$rootScope.currentProperty.name;
        this.currencySymbol = this.$rootScope.currentProperty.currency_symbol;
        this.treatment.event_status_id = (this.treatment.event_status_id) ? this.treatment.event_status_id.toString() : '0';
        this.hasIntegration = !!this.$rootScope.currentProperty.integration;
        if (this.hasIntegration) {
            this.integrationApiService.integrationTreatmentCollect(this.$rootScope.currentProperty.id).then(response => {

                this.importedTreatments = response.map(treatment => {
                    if (treatment.integration_location){
                        treatment.name = treatment.name + ' @ ' + treatment.integration_location_name;
                    }
                    return treatment;
                });
            });
        }
    }

    onSave () {
        if (!find(this.treatment.selectedcategories, { id: this.treatment.primary_category})){
            this.messageService.failure(`You must select at least 1 category and set a primary category to continue`);
            this.messageService.push();
            this.saving = undefined;
            return Promise.reject({});
        }
        
        this.messageService.reset();

        this.treatment.categories = map(this.treatment.selectedcategories, 'id');

        let tempCats = this.treatment.selectedcategories;
        let tempPrimaryCat = this.treatment.primary_category;
        delete this.treatment.selectedcategories;

        delete this.treatment.extras;
        delete this.treatment.options;
        delete this.treatment.related;
        delete this.treatment.times;
        delete this.treatment.upgrades;
        delete this.treatment.days;

        return this.treatmentsService.save(this.treatment)
            .then(response => {
                if (this.treatment.id) {
                    this.messageService.success(`The treatment <strong>${this.treatment.name}</strong> was successfully updated!`, [`app.admin.treatment-edit({ 'treatment' : ${this.treatment.id}})`, `Treatment`]);
                    this.$state.go('app.admin.treatments');
                } else {
                    this.treatment.selectedcategories = tempCats;
                    this.treatment.primary_category = tempPrimaryCat;
                    this.messageService.success(`The Treatment <strong>${this.treatment.name}</strong> was successfully created. Please edit the start times.`);
                    this.$state.go('app.admin.treatment-edit', { treatment: response.id, tab: 'times' });
                }
            })
            .catch((error) => {
                error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

                this.treatment.selectedcategories = tempCats;
                this.treatment.primary_category = tempPrimaryCat;

                let sourceElement = Object.keys(error.data);
                let verb = 'created';
                if (this.treatment.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    let errors = '';
                    for (let element of sourceElement) {
                        errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
                    }
                    this.messageService.failure(`The Treatment <strong>${this.treatment.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
                } else {
                    this.messageService.failure(`The Treatment <strong>${this.treatment.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
                }
                this.messageService.push();
            });
    }

    initialSlug () {
        if (!this.treatment.id && this.$scope.$ctrl.form.slug.$untouched) {
            this.treatment.slug = (this.treatment.name ? this.treatment.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '');
        }
    }
}

TreatmentFormController.$inject = ['$rootScope', '$scope', '$state', 'treatmentsService', 'integrationApiService', 'messageService', 'markdownService', 'configService', 'access'];

export default TreatmentFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/controllers/treatment.form.controller.js